// extracted by mini-css-extract-plugin
export var createdDate = "_nc-1";
export var divider = "_nc-2";
export var headerDivider = "_nc-3";
export var messagesCard = "_nc-0";
export var messagesContainer = "_nc-6";
export var messagesContainerWrapper = "_nc-4";
export var showLeftPanelButton = "_nc-8";
export var topButtons = "_nc-7";
export var withPadding = "_nc-5";